import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_menu-project-adcept",
  "use": "svg_menu-project-adcept-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"svg_menu-project-adcept\"><path d=\"M8.5 2A1.5 1.5 0 0 1 10 3.5v8A1.5 1.5 0 0 1 8.5 13h-5A1.5 1.5 0 0 1 2 11.5v-8A1.5 1.5 0 0 1 3.5 2h5Z\" stroke=\"currentColor\" stroke-width=\"2\" /><path d=\"M4.3 5.902a.5.5 0 0 1 .765-.424L7.62 7.076a.5.5 0 0 1 0 .848L5.065 9.522a.5.5 0 0 1-.765-.424V5.902Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol